import styled from 'styled-components'

const MyDiv = styled.div`
.flex_header{
    align-items: center;
    justify-content: space-between;
}

.overview_card {
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}
.green {
  background-color: #D0FAE6;
}
.orange {
  background-color:#FFEED4;
}


`
export default MyDiv
